import { render, staticRenderFns } from "./session-label.vue?vue&type=template&id=2434c05c&scoped=true&"
import script from "./session-label.vue?vue&type=script&lang=ts&"
export * from "./session-label.vue?vue&type=script&lang=ts&"
import style0 from "./session-label.vue?vue&type=style&index=0&id=2434c05c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2434c05c",
  null
  
)

export default component.exports